import { addDays } from "date-fns"

export function addToCart(plano) {
	localStorage.setItem('sigas:carrinho', JSON.stringify({
		expiracao: addDays(new Date(), 3),
		id: plano.id,
		descricao: plano.descricao,
		valor: plano.valor,
		periodo: plano.periodo,
		modulo: {
			id: plano.modulo.id,
			descricao: plano.modulo.descricao
		},
		identificador: plano.identificador
	}))
}